export const environmentCommon = {
    storageKeys: {
        appPrefix : 'scientifica-cms',
        authData: 'AuthData',
        authToken: 'AuthToken',
        pushSub : "pushSub"
    },
    cacheTimes: {
        defaultMaxAge: 6000
    },
    apiKeys: {},
};
